import type { QueryParamsDto } from "@mimber/schema"

/**
 * Query key utilities for group roles hooks
 * Keys match backend controller method names
 */
export const groupRolesKeys = {
  findAll: (groupUuid: string, params?: QueryParamsDto) =>
    params
      ? (["group-roles", groupUuid, "findAll", params] as const)
      : (["group-roles", groupUuid, "findAll"] as const),
  findOne: (groupUuid: string, roleUuid: string) =>
    ["group-roles", groupUuid, "findOne", roleUuid] as const,
} as const
